import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * Componente reutilizable de Tabs
 * @param {Array} tabs - [{ key, label, icon }]
 * @param {string} selectedTab
 * @param {function} onTabSelect
 * @param {object} style - estilos extra para el contenedor
 * @param {object} buttonStyle - estilos extra para los botones
 */
const TabsWidget = ({ tabs, selectedTab, onTabSelect, style = {}, buttonStyle = {} }) => {
  return (
    <div style={{ display: 'flex', gap: 16, marginBottom: 32, ...style }}>
      {tabs.map(tab => {
        // Colores distintivos para cada tab activo
        let activeBg = '#1da1f2';
        let activeColor = '#fff';
        let activeBorder = '2px solid #1da1f2';
        if (tab.key === 'APPROVED') {
          activeBg = '#27ae60';
          activeBorder = '2px solid #27ae60';
        }
        if (tab.key === 'REJECTED') {
          activeBg = '#ff0000';
          activeBorder = '2px solid #ff0000';
        }
        return (
          <button
            key={tab.key}
            onClick={() => onTabSelect(tab.key)}
            style={{
              padding: '10px 24px',
              borderRadius: 8,
              border: selectedTab === tab.key ? activeBorder : '2px solid #eee',
              background: selectedTab === tab.key ? activeBg : '#fff',
              color: selectedTab === tab.key ? activeColor : (tab.key === 'APPROVED' ? '#27ae60' : tab.key === 'REJECTED' ? '#ff0000' : '#1da1f2'),
              fontWeight: 600,
              fontSize: 16,
              cursor: 'pointer',
              transition: 'all 0.2s',
              display: 'flex', alignItems: 'center', gap: 8,
              ...buttonStyle
            }}
          >
            {tab.icon && <FontAwesomeIcon icon={tab.icon} />} {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default TabsWidget; 